
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { defineComponent } from 'vue';
import { Insomnia } from "@awesome-cordova-plugins/insomnia/index";

export default defineComponent({
  name: 'App',
  components: {
    IonApp,
    IonRouterOutlet
  } , created() {
    // console.log(ayahNumber)
    Insomnia.keepAwake().then(
      () => console.log("success"),
      () => console.log("error")
    );
  },
});
